// Super-admin payroll configuration: work week, period frequency, OT rule,
// PTO rule, approval chain toggles.

import { useEffect, useState } from 'react';
import { api } from '../../api';

export default function PayrollSettingsPage() {
  const [s, setS] = useState(null);
  const [err, setErr] = useState('');
  const [savedAt, setSavedAt] = useState(null);

  useEffect(() => { api.payrollSettings().then(setS).catch(e => setErr(e.message)); }, []);

  function set(k, v) { setS(prev => ({ ...prev, [k]: v })); }
  async function save() {
    setErr('');
    try {
      const r = await api.updatePayrollSettings(s);
      setS(r);
      setSavedAt(new Date().toLocaleTimeString());
    } catch (e) { setErr(e.message); }
  }

  if (!s) return <div className="page">Loading…</div>;

  return (
    <div className="page">
      <div className="page-header"><h2>Payroll Settings</h2></div>
      {err && <div className="error-banner">{err}</div>}
      <div className="form-grid">
        <label>Work week starts on
          <select value={s.work_week_start_day ?? 1} onChange={e => set('work_week_start_day', parseInt(e.target.value, 10))}>
            <option value="0">Sunday</option><option value="1">Monday</option><option value="2">Tuesday</option>
            <option value="3">Wednesday</option><option value="4">Thursday</option><option value="5">Friday</option><option value="6">Saturday</option>
          </select>
        </label>
        <label>Work week start hour (24h)
          <input type="number" min="0" max="23" value={s.work_week_start_hour ?? 0}
            onChange={e => set('work_week_start_hour', parseInt(e.target.value, 10) || 0)} />
        </label>
        <label>Pay period frequency
          <select value={s.pay_period_frequency || 'biweekly'} onChange={e => set('pay_period_frequency', e.target.value)}>
            <option value="weekly">Weekly</option>
            <option value="biweekly">Bi-weekly</option>
            <option value="semimonthly">Semi-monthly</option>
            <option value="monthly">Monthly</option>
          </select>
        </label>
        <label>Pay period anchor date
          <input type="date" value={s.pay_period_anchor_date || ''}
            onChange={e => set('pay_period_anchor_date', e.target.value || null)} />
        </label>
        <label>Overtime rule
          <select value={s.ot_rule || 'over_40_weekly'} onChange={e => set('ot_rule', e.target.value)}>
            <option value="over_40_weekly">Over 40 hours per week</option>
            <option value="over_8_daily">Over 8 hours per day</option>
            <option value="none">No overtime</option>
          </select>
        </label>
        <label>PTO accrual rule
          <select value={s.pto_accrual_rule || 'per_hour_worked'} onChange={e => set('pto_accrual_rule', e.target.value)}>
            <option value="per_hour_worked">Per hour worked</option>
            <option value="per_pay_period">Per pay period</option>
            <option value="manual">Manual only</option>
          </select>
        </label>
        <label>
          <input type="checkbox" checked={!!s.manager_approval_required} onChange={e => set('manager_approval_required', e.target.checked ? 1 : 0)} />
          Require manager approval on timecards
        </label>
        <label>
          <input type="checkbox" checked={!!s.payroll_approval_required} onChange={e => set('payroll_approval_required', e.target.checked ? 1 : 0)} />
          Require payroll-admin approval on pay periods
        </label>
      </div>
      <div className="form-actions">
        <button className="btn-primary" onClick={save}>Save</button>
        {savedAt && <span className="muted">Saved at {savedAt}</span>}
      </div>
    </div>
  );
}
